export default __webpack_public_path__ + "static/media/krilnekapije1.8bc80f17.png";